<template>
  <div class="content">
    <div class="content__title content__title--party">
      <h1 class="title title--big title--theme">Отчётность</h1>
      <div v-if="userRole === 'admin'" class="search">
        <v-select
          @search="onSearch"
          @input="onSetOrganization"
          v-model="region_result"
          :reduce="org => org.id"
          :filterable="false"
          :clearable="false"
          :options="region_options"
          :get-option-label="getLabel"
          placeholder="Выберите региональную организацию"
          class="select"
        >
          <template slot="open-indicator">
            <svg class="select__open-indicator" xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="none">
              <path clip-rule="evenodd" d="M10.06 17.25a7.19 7.19 0 100-14.38 7.19 7.19 0 000 14.38z" stroke="#C7CFDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M20.12 20.12l-4.98-4.98" stroke="#C7CFDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </template>
          <template slot="no-options">Введите свой запрос для поиска</template>
          <template slot="option" slot-scope="option">
            <div class="select__item d-center">
              {{ option.name }} (ID: {{ option.id }}) ({{ option.group_name }})
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name }} (ID: {{ option.id }}) ({{ option.group_name }})
            </div>
          </template>
        </v-select>
      </div>
    </div>
    <div class="report">
      <div v-if="userRegion" class="report__list">
        <a :href="$router.resolve({ name: 'head' }).href" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInBlock('HeadQuestionnaire') }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>1</span>
          </div>
          <div class="report__title">Анкета руководителя</div>
        </a>
        <router-link :to="{ name: 'passport' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInBlock('PassportQuestionnaire') }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>2</span>
          </div>
          <div class="report__title">Паспорт РО РСМ</div>
        </router-link>
        <router-link :to="{ name: 'local' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInBlock('LocalOrganization') }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>3</span>
          </div>
          <div class="report__title">Местные организации</div>
        </router-link>
        <router-link :to="{ name: 'primary' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInBlock('PrimaryGroup') }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>4</span>
          </div>
          <div class="report__title">Первичные группы</div>
        </router-link>
        <router-link :to="{ name: 'meeting' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInBlock('MeetingGoverningBody') || hasUnacceptedInBlock('SupremeBody') }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>5</span>
          </div>
          <div class="report__title">Заседания руководящих органов</div>
        </router-link>
        <router-link :to="{ name: 'justice' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInBlock('Justice') }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>6</span>
          </div>
          <div class="report__title">Отчетность в территориальные органы Минюста РФ</div>
        </router-link>
        <router-link :to="{ name: 'balance' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInBlock('BalanceSheet') }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>7</span>
          </div>
          <div class="report__title">Бухгалтерский баланс</div>
        </router-link>
        <router-link :to="{ name: 'program' }" class="report__item">
          <div class="report__number">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>8</span>
          </div>
          <div class="report__title">Уведомление о реализации программ и проектов</div>
        </router-link>
        <router-link :to="{ name: 'information' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInInformation }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>9</span>
          </div>
          <div class="report__title">Информационное обеспечение деятельности</div>
        </router-link>
        <router-link :to="{ name: 'agreement' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInBlock('ActiveAgreement') }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>10</span>
          </div>
          <div class="report__title">Соглашения о сотрудничестве с партнерами</div>
        </router-link>
        <router-link :to="{ name: 'grant' }" class="report__item">
          <div class="report__number">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>11</span>
          </div>
          <div class="report__title">Грантовые конкурсы</div>
        </router-link>
        <router-link :to="{ name: 'school' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInBlock('Person') }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>12</span>
          </div>
          <div class="report__title">Кадровые школы</div>
        </router-link>
        <router-link :to="{ name: 'event-plan' }" class="report__item">
          <div class="report__number" :class="{ 'report__number--changed': hasUnacceptedInBlock('EventPlan') }">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>13</span>
          </div>
          <div class="report__title">План мероприятий РО РСМ</div>
        </router-link>
        <router-link :to="{ name: 'interaction' }" class="report__item">
          <div class="report__number">
            <img src="@/assets/img/number-leaf.svg" alt="Leaf">
            <span>14</span>
          </div>
          <div class="report__title">Взаимодействие с внешней средой</div>
        </router-link>
      </div>
      <div v-else class="report__slug">
        <div class="report__slug-pic">
          <img src="@/assets/img/local-icon.svg" alt="Local">
        </div>
        <div class="report__slug-title">Выберите региональную организацию</div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import axios from '@/http/axios/axios';

export default {
  name: 'Report',
  data() {
    return {
      region_result: '',
      region_options: [],
      // Используем обычный объект — он реактивен в Vue 2
      modelUnacceptedCache: {},
    };
  },
  computed: {
    userRegion() {
      return this.$store.state.organization;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    hasUnacceptedInInformation() {
      return (
        this.hasUnacceptedInBlock('FederalPublication') ||
        this.hasUnacceptedInBlock('RegionPublication') ||
        this.hasUnacceptedInBlock('SimplePublication')
      );
    },
  },
  mounted() {
    if (this.userRegion) {
      this.region_result = this.userRegion;
    }
    this.$store.dispatch('regOrg/GET_QUERY').then(response => {
      this.region_options = response.data;
      if (this.userRegion) {
        this.loadStatuses();
      }
    });
  },
  methods: {
    getLabel(option) {
      if (typeof option === 'object' && option.name) {
        return option.name;
      }
      return option;
    },

    hasUnacceptedInBlock(modelName) {
      return this.modelUnacceptedCache[modelName] === true;
    },

    async loadStatuses() {
  if (!this.region_result) {
    console.warn('[Report] Нет region_org_id — пропуск загрузки статусов');
    return;
  }

  console.log('[Report] Загрузка статусов для региона:', this.region_result);

  try {
    const response = await axios.get('/user/users/unified-history/', {
      params: {
        region_org_id: this.region_result,
        page_size: 1000,
      },
    });

    const records = response.data.results || [];
    console.log(`[Report] Получено записей из истории: ${records.length}`);

    // Группируем по object_id и берём самую свежую запись
    const latestByObject = new Map();
    for (const entry of records) {
      const key = `${entry.model_name}-${entry.object_id}`;
      if (!latestByObject.has(key)) {
        latestByObject.set(key, entry);
      }
    }

    const unacceptedModels = new Set();

    for (const entry of latestByObject.values()) {
      // ❌ Если последнее действие — УДАЛЕНИЕ → не учитываем
      if (entry.action_type === '-') {
        continue;
      }

      const changes = entry.changes || {};
      let status = null;

      // Берём статус из изменений
      if (changes.status?.new !== undefined) {
        status = String(changes.status.new).trim();
      }
      // Или из current_status (если backend его отдаёт)
      else if (entry.current_status !== undefined) {
        status = String(entry.current_status).trim();
      }

      // ✅ Подсвечиваем ТОЛЬКО если статус существует и НЕ "Принята"/"accepted"
      if (status && !['accepted', 'Принята'].includes(status)) {
        unacceptedModels.add(entry.model_name);
      }
    }

    // Обновляем реактивный кэш
    this.$set(this, 'modelUnacceptedCache', {});
    for (const model of unacceptedModels) {
      this.$set(this.modelUnacceptedCache, model, true);
    }

    console.log('[Report] Непринятые модели (актуальные, без удалённых):', Array.from(unacceptedModels));
  } catch (e) {
    console.error('[Report] Ошибка загрузки статусов:', e);
  }
},

    async onSetOrganization() {
      console.log('[Report] Смена региона на:', this.region_result);
      await this.$store.dispatch('profile/UPDATE_ORG', { region_org: this.region_result });
      await this.$store.dispatch('profile/GET_DATA');
      this.$store.commit('setOrganization', this.region_result);
      await this.loadStatuses();
    },

    onSearch(search, loading) {
      loading(true);
      this.searchDelivery(loading, search, this);
    },

    searchDelivery: debounce((loading, search, vm) => {
      vm.$store.dispatch('regOrg/GET_QUERY', search).then(response => {
        vm.region_options = response.data;
        loading(false);
      });
    }, 350),
  },
  watch: {
    userRegion(newVal) {
      if (newVal && newVal !== this.region_result) {
        this.region_result = newVal;
        this.loadStatuses();
      }
    },
  },
};
</script>

<style scoped>
/* Надёжная подсветка: фон + border */
.report__number--changed {
filter: hue-rotate(176deg) saturate(1.5);
}
</style>